import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Input } from "rsuite";

const BranchModal = ({
  isOpen,
  onClose,
  onSave,
  mode = "add",
  initialValues,
}) => {
  const [form, setForm] = useState({ name: "", address: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (initialValues) {
        setForm({
          name: initialValues.name ?? "",
          address: initialValues.address ?? "",
        });
      } else {
        setForm({ name: "", address: "" });
      }
      setErrors({});
    }
  }, [isOpen, initialValues]);

  const validate = () => {
    const nextErrors = {};

    if (!form.name.trim()) {
      nextErrors.name = "Branch name is required";
    }

    if (!form.address.trim()) {
      nextErrors.address = "Address is required";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    setSubmitting(true);
    const payload = {
      name: form.name.trim(),
      address: form.address.trim(),
    };
    onSave(payload);
    setSubmitting(false);
  };

  const handleClose = () => {
    if (submitting) return;
    setErrors({});
    onClose();
  };

  return (
    <Modal open={isOpen} onClose={handleClose} backdrop={submitting ? "static" : true} size="sm">
      <Modal.Header>
        <Modal.Title>{mode === "edit" ? "Edit branch" : "Add branch"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form fluid>
          <Form.Group>
            <Form.ControlLabel>Branch name</Form.ControlLabel>
            <Input
              name="name"
              placeholder="e.g. Kothrud Branch"
              value={form.name}
              onChange={(value) => setForm((prev) => ({ ...prev, name: value }))}
              errorMessage={errors.name}
            />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>Address</Form.ControlLabel>
            <Input
              name="address"
              placeholder="e.g. 123 Main Road, Kothrud, Pune"
              value={form.address}
              onChange={(value) => setForm((prev) => ({ ...prev, address: value }))}
              errorMessage={errors.address}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={handleClose} appearance="subtle" disabled={submitting}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          appearance="primary"
          style={{ backgroundColor: "#198754", color: "white" }}
          disabled={submitting}
        >
          {submitting
            ? mode === "edit"
              ? "Saving…"
              : "Adding…"
            : mode === "edit"
            ? "Save changes"
            : "Add branch"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BranchModal;
